import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="card, profile, avatar, account"><path d="M4.75 2.75H19.25V21.25H4.75V2.75Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="9" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M8 14H16" stroke="currentColor" strokeWidth="1.5"/><path d="M8 17H16" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCard;
